// // import { useEffect } from "react";
// // import styles from "../HealthChat.module.css";
// // import { getAgeGroup } from "../../../utils/ageUtil";
// // import { useAuth } from '../../../hooks/useAuth';
// // import { storePatientSession } from '../../../utils/storage/authStorage';

// // const ROUTINES = [
// //   { label: "Working", emoji: "👔" },
// //   { label: "Homemaker", emoji: "🏠" },
// //   { label: "Student", emoji: "🎓" },
// // ];
// // const MARITAL_OPTS = ["Single", "Married", "Divorced", "Prefer not to say"];

// // export default function PersonalizePersonaScreen({
// //   patientState,
// //   onPatientStateChange,
// //   onComplete,
// //   onBack,
// // }) {
// //   const { user } = useAuth();

// //   // Destructure from shared state
// //   const {
// //     dob = '',
// //     ageGroup = '',
// //     occupation = '',
// //     marital = '',
// //     heightIn = 160,
// //     weightIn = 60,
// //     errors = {},
// //   } = patientState;

// //   const set = (d) => onPatientStateChange(d);

// //   // Pre-fill from auth session only once (when fields are empty)
// //   useEffect(() => {
// //     if (!user) return;
// //     if (!ageGroup && user.ageGroup) set({ ageGroup: user.ageGroup });
// //     if (!marital && user.maritalStatus) set({ marital: user.maritalStatus });
// //     if (!occupation && user.occupation) set({ occupation: user.occupation });
// //   }, [user]);

// //   /* ─── Validation ─────────────────────────────────────────────────────── */
// //   function validate() {
// //     const e = {};
// //     if (!ageGroup) e.ageGroup = true;
// //     if (!occupation) e.routine = true;
// //     return e;
// //   }

// //   /* ─── Continue ───────────────────────────────────────────────────────── */
// //   function handleContinue() {
// //     const e = validate();
// //     if (Object.keys(e).length) {
// //       set({ errors: { ...errors, ...e } });
// //       return;
// //     }

// //     const data = {
// //       ageGroup,
// //       occupation,
// //       marital,
// //       heightIn,
// //       weightIn,
// //       dob,
// //     };

// //     // Persist additional persona fields into the patient session
// //     try {
// //       storePatientSession({
// //         ageGroup,
// //         occupation,
// //         maritalStatus: marital,
// //         heightIn,
// //         weightIn,
// //       });
// //     } catch (_) {}

// //     try {
// //       localStorage.setItem(
// //         "patientPersona",
// //         JSON.stringify({ ...data, savedAt: Date.now() }),
// //       );
// //     } catch (_) {}

// //     onComplete(data);
// //   }
// // // const AGE_OPTIONS        = ["18–25", "26–35", "36–45", "46–55", "56+"];
// // const AGE_OPTIONS=["10–14 years","15–19 years","20–25 years","26–35 years","36–45 years","46–55 years","55–64 years","65+ years"]
// //   return (
// //     <div className={styles.personaScreen2}>
// //       <div className={styles.persona2Body}>
// //         <button className={styles.selectDoctorBack} onClick={onBack}>
// //           ← Back
// //         </button>

// //         {/* Date of Birth */}
// //         {/* <div className={styles.persona2Section}>
// //           <div className={`ava-text-body  ${styles.CBheading3}`}>
// //             What's your date of birth?
// //             {errors.ageGroup && (
// //               <span className={styles.persona2Required}> *required</span>
// //             )}
// //           </div>

// //           <input
// //             type="date"
// //             value={dob}
// //             max={new Date().toISOString().split("T")[0]}
// //             onChange={(e) => {
// //               const value = e.target.value;
// //               const calculatedAgeGroup = getAgeGroup(value);
// //               set({
// //                 dob: value,
// //                 ageGroup: calculatedAgeGroup,
// //                 errors: { ...errors, ageGroup: false },
// //               });
// //             }}
// //             className={styles.persona2Input}
// //           />
// //         </div> */}
// //         <div className={styles.persona2Section}>
// //           <div className={`ava-text-body  ${styles.CBheading3}`}>
// //             What's your age group?
// //             {errors.ageGroup && (
// //               <span className={styles.persona2Required}> *required</span>
// //             )}
// //           </div>

// //          <div className={styles.persona2RoutineRow}>
// //     {AGE_OPTIONS.map((age) => (
// //       <button
// //         key={age}
// //         type="button"
// //         className={`${styles.CBbodyText} ${
// //           ageGroup === age
// //             ? styles.persona2RoutineActive
// //             : styles.persona2Routine
// //         }`}
// //         onClick={() => {
// //           set({
// //             ageGroup: age,
// //             errors: { ...errors, ageGroup: false },
// //           });
// //         }}
// //       >
// //         {age}
// //       </button>
// //     ))}
// //   </div>
// //         </div>

// //         {/* Daily Routine / Occupation */}
// //         <div className={styles.persona2Section}>
// //           <div className={`ava-text-body ${styles.CBheading3}`}>
// //             What describes your daily routine?
// //             {errors.routine && (
// //               <span className={styles.persona2Required}> *required</span>
// //             )}
// //           </div>
// //           <div className={styles.persona2RoutineRow}>
// //             {ROUTINES.map(({ label }) => (
// //               <button
// //                 key={label}
// //                 className={`${styles.CBbodyText} ${
// //                   occupation === label
// //                     ? styles.persona2RoutineActive
// //                     : styles.persona2Routine
// //                 }`}
// //                 onClick={() => {
// //                   set({ occupation: label, errors: { ...errors, routine: false } });
// //                 }}
// //               >
// //                 {label}
// //               </button>
// //             ))}
// //           </div>
// //         </div>

// //         {/* Marital Status */}
// //         <div className={styles.persona2Section}>
// //           <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
// //             What is your marital status?
// //           </div>
// //           <div className={`${styles.persona2MaritalRow} ${styles.CBbodyText}`}>
// //             {MARITAL_OPTS.map((opt) => (
// //               <button
// //                 key={opt}
// //                 className={`${styles.CBbodyText} ${
// //                   marital === opt
// //                     ? styles.persona2ChipActive
// //                     : styles.persona2Chip
// //                 }`}
// //                 onClick={() => set({ marital: marital === opt ? "" : opt })}
// //               >
// //                 {opt}
// //               </button>
// //             ))}
// //           </div>
// //         </div>

// //         {/* Physical Details */}
// //         <div className={styles.persona2Section}>
// //           <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
// //             Your physical measurements
// //           </div>
// //           <div className={styles.persona2PhysicalRow}>
// //             <div className={styles.persona2PhysicalField}>
// //               <label
// //                 className={`${styles.persona2PhysLabel} ${styles.CBbodyText}`}
// //               >
// //                 Height : {heightIn} cm
// //               </label>
// //               <input
// //                 className={`${styles.persona2Input} ${styles.persona2Slider}`}
// //                 type="range"
// //                 min="100"
// //                 max="250"
// //                 value={heightIn}
// //                 onChange={(e) => set({ heightIn: Number(e.target.value) })}
// //               />
// //             </div>
// //             <div className={styles.persona2PhysicalField}>
// //               <label
// //                 className={`${styles.persona2PhysLabel} ${styles.CBheading3}`}
// //               >
// //                 Weight: {weightIn} kg
// //               </label>
// //               <input
// //                 className={`${styles.persona2Input} ${styles.persona2Slider}`}
// //                 type="range"
// //                 min="20"
// //                 max="300"
// //                 value={weightIn ?? 60}
// //                 onChange={(e) => set({ weightIn: Number(e.target.value) })}
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Continue */}
// //         <button
// //           className={`${styles.persona2ContinueBtn} ${styles.CBheading3}`}
// //           onClick={handleContinue}
// //         >
// //           Continue →
// //         </button>
// //       </div>
// //     </div>
// //   );
// // }


// import { useEffect } from "react";
// import styles from "../HealthChat.module.css";
// import { getAgeGroup } from "../../../utils/ageUtil";
// import { useAuth } from '../../../hooks/useAuth';
// import { storePatientSession } from '../../../utils/storage/authStorage';
// import { HEIGHT_DEFAULT_IN, HEIGHT_MIN_IN, HEIGHT_MAX_IN, WEIGHT_DEFAULT_KG, WEIGHT_MIN_KG, WEIGHT_MAX_KG } from "../../../config/constants";
// import { toFtIn } from "../../../pages/CareNavigator";

// const ROUTINES = [
//   { label: "Working", emoji: "👔" },
//   { label: "Homemaker", emoji: "🏠" },
//   { label: "Student", emoji: "🎓" },
// ];
// const MARITAL_OPTS = ["Single", "Married", "Divorced", "Prefer not to say"];

// export default function PersonalizePersonaScreen({
//   patientState,
//   onPatientStateChange,
//   onComplete,
//   onBack,
// }) {
//   const { user } = useAuth();

//   const {
//     dob = '',
//     ageGroup = '',
//     occupation = '',
//     marital = '',
//     heightIn = HEIGHT_DEFAULT_IN,
//     weightIn = WEIGHT_DEFAULT_KG,
//     errors = {},
//   } = patientState;

//   const set = (d) => onPatientStateChange(d);

//   useEffect(() => {
//     if (!user) return;
//     if (!ageGroup && user.ageGroup) set({ ageGroup: user.ageGroup });
//     if (!marital && user.maritalStatus) set({ marital: user.maritalStatus });
//     if (!occupation && user.occupation) set({ occupation: user.occupation });
//   }, [user]);

//   function validate() {
//     const e = {};
//     if (!ageGroup) e.ageGroup = true;
//     if (!occupation) e.routine = true;
//     return e;
//   }

//   function handleContinue() {
//     const e = validate();
//     if (Object.keys(e).length) {
//       set({ errors: { ...errors, ...e } });
//       return;
//     }

//     const data = {
//       ageGroup,
//       occupation,
//       marital,
//       heightIn,
//       weightIn,
//       dob,
//     };

//     try {
//       storePatientSession({
//         ageGroup,
//         occupation,
//         maritalStatus: marital,
//         heightIn,
//         weightIn,
//       });
//     } catch (_) {}

//     try {
//       localStorage.setItem(
//         "patientPersona",
//         JSON.stringify({ ...data, savedAt: Date.now() }),
//       );
//     } catch (_) {}

//     onComplete(data);
//   }

//   return (
//     <div className={styles.personaScreen2}>
//       <div className={styles.persona2Body}>
//         <button className={styles.selectDoctorBack} onClick={onBack}>
//           ← Back
//         </button>

//         {/* Date of Birth */}
//         <div className={styles.persona2Section}>
//           <div className={`ava-text-body  ${styles.CBheading3}`}>
//             What's your date of birth?
//             {errors.ageGroup && (
//               <span className={styles.persona2Required}> *required</span>
//             )}
//           </div>

//           <input
//             type="date"
//             value={dob}
//             max={new Date().toISOString().split("T")[0]}
//             onChange={(e) => {
//               const value = e.target.value;
//               const calculatedAgeGroup = getAgeGroup(value);
//               set({
//                 dob: value,
//                 ageGroup: calculatedAgeGroup,
//                 errors: { ...errors, ageGroup: false },
//               });
//             }}
//             className={styles.persona2Input}
//           />
//         </div>

//         {/* Daily Routine / Occupation */}
//         <div className={styles.persona2Section}>
//           <div className={`ava-text-body ${styles.CBheading3}`}>
//             What describes your daily routine?
//             {errors.routine && (
//               <span className={styles.persona2Required}> *required</span>
//             )}
//           </div>
//           <div className={styles.persona2RoutineRow}>
//             {ROUTINES.map(({ label }) => (
//               <button
//                 key={label}
//                 className={`${styles.CBbodyText} ${
//                   occupation === label
//                     ? styles.persona2RoutineActive
//                     : styles.persona2Routine
//                 }`}
//                 onClick={() => {
//                   set({ occupation: label, errors: { ...errors, routine: false } });
//                 }}
//               >
//                 {label}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Marital Status */}
//         <div className={styles.persona2Section}>
//           <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
//             What is your marital status?
//           </div>
//           <div className={`${styles.persona2MaritalRow} ${styles.CBbodyText}`}>
//             {MARITAL_OPTS.map((opt) => (
//               <button
//                 key={opt}
//                 className={`${styles.CBbodyText} ${
//                   marital === opt
//                     ? styles.persona2ChipActive
//                     : styles.persona2Chip
//                 }`}
//                 onClick={() => set({ marital: marital === opt ? "" : opt })}
//               >
//                 {opt}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Physical Details */}
//         <div className={styles.persona2Section}>
//           <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
//             Your physical measurements
//           </div>
//           <div className={styles.persona2PhysicalRow}>
//             <div className={styles.persona2PhysicalField}>
//               <label
//                 className={`${styles.persona2PhysLabel} ${styles.CBbodyText}`}
//               >
//                 Height : {toFtIn(heightIn || HEIGHT_DEFAULT_IN)}
//               </label>
//               <input
//                 className={`${styles.persona2Input} ${styles.persona2Slider}`}
//                 type="range"
//                 min={HEIGHT_MIN_IN}
//                 max={HEIGHT_MAX_IN}
//                 value={heightIn}
//                 onChange={(e) => set({ heightIn: Number(e.target.value) })}
//               />
//             </div>
//             <div className={styles.persona2PhysicalField}>
//               <label
//                 className={`${styles.persona2PhysLabel} ${styles.CBheading3}`}
//               >
//                 Weight: {weightIn || WEIGHT_DEFAULT_KG} kg
//               </label>
//               <input
//                 className={`${styles.persona2Input} ${styles.persona2Slider}`}
//                 type="range"
//                 min={WEIGHT_MIN_KG}
//                 max={WEIGHT_MAX_KG}
//                 value={weightIn ?? 60}
//                 onChange={(e) => set({ weightIn: Number(e.target.value) })}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Continue */}
//         <button
//           className={`${styles.persona2ContinueBtn} ${styles.CBheading3}`}
//           onClick={handleContinue}
//         >
//           Continue →
//         </button>
//       </div>
//     </div>
//   );
// }
// import { useEffect } from "react";
// import styles from "../HealthChat.module.css";
// import { getAgeGroup } from "../../../utils/ageUtil";
// import { useAuth } from '../../../hooks/useAuth';
// import { storePatientSession } from '../../../utils/storage/authStorage';
// import { HEIGHT_DEFAULT_IN, WEIGHT_DEFAULT_KG } from "../../../config/constants";
// import { toFtIn } from "../../../pages/CareNavigator";

// const ROUTINES = [
//   { label: "Working", emoji: "👔" },
//   { label: "Homemaker", emoji: "🏠" },
//   { label: "Student", emoji: "🎓" },
// ];
// const MARITAL_OPTS = ["Single", "Married", "Divorced", "Prefer not to say"];

// export default function PersonalizePersonaScreen({
//   patientState,
//   onPatientStateChange,
//   onComplete,
//   onBack,
// }) {
//   const { user } = useAuth();

//   // Destructure from shared state
//   const {
//     dob = '',
//     ageGroup = '',
//     occupation = '',
//     marital = '',
//     heightIn = HEIGHT_DEFAULT_IN,
//     weightIn = WEIGHT_DEFAULT_KG,
//     errors = {},
//   } = patientState;

//   const set = (d) => onPatientStateChange(d);

//   // Pre-fill from auth session only once (when fields are empty)
//   useEffect(() => {
//     if (!user) return;
//     if (!ageGroup && user.ageGroup) set({ ageGroup: user.ageGroup });
//     if (!marital && user.maritalStatus) set({ marital: user.maritalStatus });
//     if (!occupation && user.occupation) set({ occupation: user.occupation });
//   }, [user]);

//   /* ─── Validation ─────────────────────────────────────────────────────── */
//   function validate() {
//     const e = {};
//     if (!ageGroup) e.ageGroup = true;
//     if (!occupation) e.routine = true;
//     return e;
//   }

//   /* ─── Continue ───────────────────────────────────────────────────────── */
//   function handleContinue() {
//     const e = validate();
//     if (Object.keys(e).length) {
//       set({ errors: { ...errors, ...e } });
//       return;
//     }

//     const data = {
//       ageGroup,
//       occupation,
//       marital,
//       heightIn,
//       weightIn,
//       dob,
//     };

//     // Persist additional persona fields into the patient session
//     try {
//       storePatientSession({
//         ageGroup,
//         occupation,
//         maritalStatus: marital,
//         heightIn,
//         weightIn,
//       });
//     } catch (_) {}

//     try {
//       localStorage.setItem(
//         "patientPersona",
//         JSON.stringify({ ...data, savedAt: Date.now() }),
//       );
//     } catch (_) {}

//     onComplete(data);
//   }

//   return (
//     <div className={styles.personaScreen2}>
//       <div className={styles.persona2Body}>
//         <button className={styles.selectDoctorBack} onClick={onBack}>
//           ← Back
//         </button>

//         {/* Date of Birth */}
//         <div className={styles.persona2Section}>
//           <div className={`ava-text-body  ${styles.CBheading3}`}>
//             What's your date of birth?
//             {errors.ageGroup && (
//               <span className={styles.persona2Required}> *required</span>
//             )}
//           </div>

//           <input
//             type="date"
//             value={dob}
//             max={new Date().toISOString().split("T")[0]}
//             onChange={(e) => {
//               const value = e.target.value;
//               const calculatedAgeGroup = getAgeGroup(value);
//               set({
//                 dob: value,
//                 ageGroup: calculatedAgeGroup,
//                 errors: { ...errors, ageGroup: false },
//               });
//             }}
//             className={styles.persona2Input}
//           />
//         </div>

//         {/* Daily Routine / Occupation */}
//         <div className={styles.persona2Section}>
//           <div className={`ava-text-body ${styles.CBheading3}`}>
//             What describes your daily routine?
//             {errors.routine && (
//               <span className={styles.persona2Required}> *required</span>
//             )}
//           </div>
//           <div className={styles.persona2RoutineRow}>
//             {ROUTINES.map(({ label }) => (
//               <button
//                 key={label}
//                 className={`${styles.CBbodyText} ${
//                   occupation === label
//                     ? styles.persona2RoutineActive
//                     : styles.persona2Routine
//                 }`}
//                 onClick={() => {
//                   set({ occupation: label, errors: { ...errors, routine: false } });
//                 }}
//               >
//                 {label}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Marital Status */}
//         <div className={styles.persona2Section}>
//           <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
//             What is your marital status?
//           </div>
//           <div className={`${styles.persona2MaritalRow} ${styles.CBbodyText}`}>
//             {MARITAL_OPTS.map((opt) => (
//               <button
//                 key={opt}
//                 className={`${styles.CBbodyText} ${
//                   marital === opt
//                     ? styles.persona2ChipActive
//                     : styles.persona2Chip
//                 }`}
//                 onClick={() => set({ marital: marital === opt ? "" : opt })}
//               >
//                 {opt}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Physical Details */}
//         <div className={styles.persona2Section}>
//           <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
//             Your physical measurements
//           </div>
//           <div className={styles.persona2PhysicalRow}>
//             <div className={styles.persona2PhysicalField}>
//               <label
//                 className={`${styles.persona2PhysLabel} ${styles.CBbodyText}`}
//               >
//                 Height : {toFtIn(heightIn || HEIGHT_DEFAULT_IN)}
//               </label>
//               <input
//                 className={`${styles.persona2Input} ${styles.persona2Slider}`}
//                 type="range"
//                 min="100"
//                 max="250"
//                 value={heightIn}
//                 onChange={(e) => set({ heightIn: Number(e.target.value) })}
//               />
//             </div>
//             <div className={styles.persona2PhysicalField}>
//               <label
//                 className={`${styles.persona2PhysLabel} ${styles.CBheading3}`}
//               >
//                 Weight: {weightIn || WEIGHT_DEFAULT_KG} kg
//               </label>
//               <input
//                 className={`${styles.persona2Input} ${styles.persona2Slider}`}
//                 type="range"
//                 min="20"
//                 max="300"
//                 value={weightIn ?? 60}
//                 onChange={(e) => set({ weightIn: Number(e.target.value) })}
//               />
//             </div>
//           </div>
//         </div>

//         {/* Continue */}
//         <button
//           className={`${styles.persona2ContinueBtn} ${styles.CBheading3}`}
//           onClick={handleContinue}
//         >
//           Continue →
//         </button>
//       </div>
//     </div>
//   );
// }
import { useEffect } from "react";
import styles from "../HealthChat.module.css";
import { getAgeGroup } from "../../../utils/ageUtil";
import { useAuth } from '../../../hooks/useAuth';
import { storePatientSession } from '../../../utils/storage/authStorage';
import { HEIGHT_DEFAULT_IN, HEIGHT_MIN_IN, HEIGHT_MAX_IN, WEIGHT_DEFAULT_KG, WEIGHT_MIN_KG, WEIGHT_MAX_KG } from "../../../config/constants";
import { toFtIn } from "../../../pages/CareNavigator";

const ROUTINES = [
  { label: "Working", emoji: "👔" },
  { label: "Homemaker", emoji: "🏠" },
  { label: "Student", emoji: "🎓" },
];
const MARITAL_OPTS = ["Single", "Married", "Divorced", "Prefer not to say"];

export default function PersonalizePersonaScreen({
  patientState,
  onPatientStateChange,
  onComplete,
  onBack,
}) {
  const { user } = useAuth();

  const {
    dob = '',
    ageGroup = '',
    occupation = '',
    marital = '',
    heightIn = HEIGHT_DEFAULT_IN,
    weightIn = WEIGHT_DEFAULT_KG,
    errors = {},
  } = patientState;

  const set = (d) => onPatientStateChange(d);

  useEffect(() => {
    if (!user) return;
    if (!ageGroup && user.ageGroup) set({ ageGroup: user.ageGroup });
    if (!marital && user.maritalStatus) set({ marital: user.maritalStatus });
    if (!occupation && user.occupation) set({ occupation: user.occupation });
  }, [user]);

  function validate() {
    const e = {};
    if (!ageGroup) e.ageGroup = true;
    if (!occupation) e.routine = true;
    return e;
  }

  function handleContinue() {
    const e = validate();
    if (Object.keys(e).length) {
      set({ errors: { ...errors, ...e } });
      return;
    }

    const data = {
      ageGroup,
      occupation,
      marital,
      heightIn,
      weightIn,
      dob,
    };

    try {
      storePatientSession({
        ageGroup,
        occupation,
        maritalStatus: marital,
        heightIn,
        weightIn,
      });
    } catch (_) {}

    try {
      localStorage.setItem(
        "patientPersona",
        JSON.stringify({ ...data, savedAt: Date.now() }),
      );
    } catch (_) {}

    onComplete(data);
  }

  return (
    <div className={styles.personaScreen2}>
      <div className={styles.persona2Body}>
        <button className={styles.selectDoctorBack} onClick={onBack}>
          ← Back
        </button>

        {/* Date of Birth */}
        <div className={styles.persona2Section}>
          <div className={`ava-text-body  ${styles.CBheading3}`}>
            What's your date of birth?
            {errors.ageGroup && (
              <span className={styles.persona2Required}> *required</span>
            )}
          </div>

          <input
            type="date"
            value={dob}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => {
              const value = e.target.value;
              const calculatedAgeGroup = getAgeGroup(value);
              set({
                dob: value,
                ageGroup: calculatedAgeGroup,
                errors: { ...errors, ageGroup: false },
              });
            }}
            className={styles.persona2Input}
          />
        </div>

        {/* Daily Routine / Occupation */}
        <div className={styles.persona2Section}>
          <div className={`ava-text-body ${styles.CBheading3}`}>
            What describes your daily routine?
            {errors.routine && (
              <span className={styles.persona2Required}> *required</span>
            )}
          </div>
          <div className={styles.persona2RoutineRow}>
            {ROUTINES.map(({ label }) => (
              <button
                key={label}
                className={`${styles.CBbodyText} ${
                  occupation === label
                    ? styles.persona2RoutineActive
                    : styles.persona2Routine
                }`}
                onClick={() => {
                  set({ occupation: label, errors: { ...errors, routine: false } });
                }}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Marital Status */}
        <div className={styles.persona2Section}>
          <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
            What is your marital status?
          </div>
          <div className={`${styles.persona2MaritalRow} ${styles.CBbodyText}`}>
            {MARITAL_OPTS.map((opt) => (
              <button
                key={opt}
                className={`${styles.CBbodyText} ${
                  marital === opt
                    ? styles.persona2ChipActive
                    : styles.persona2Chip
                }`}
                onClick={() => set({ marital: marital === opt ? "" : opt })}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>

        {/* Physical Details */}
        <div className={styles.persona2Section}>
          <div className={`${styles.persona2Label} ${styles.CBheading3}`}>
            Your physical measurements
          </div>
          <div className={styles.persona2PhysicalRow}>
            <div className={styles.persona2PhysicalField}>
              <label
                className={`${styles.persona2PhysLabel} ${styles.CBbodyText}`}
              >
                Height : {toFtIn(heightIn || HEIGHT_DEFAULT_IN)}
              </label>
              <input
                className={`${styles.persona2Input} ${styles.persona2Slider}`}
                type="range"
                min={HEIGHT_MIN_IN}
                max={HEIGHT_MAX_IN}
                value={heightIn}
                onChange={(e) => set({ heightIn: Number(e.target.value) })}
              />
            </div>
            <div className={styles.persona2PhysicalField}>
              <label
                className={`${styles.persona2PhysLabel} ${styles.CBheading3}`}
              >
                Weight: {weightIn || WEIGHT_DEFAULT_KG} kg
              </label>
              <input
                className={`${styles.persona2Input} ${styles.persona2Slider}`}
                type="range"
                min={WEIGHT_MIN_KG}
                max={WEIGHT_MAX_KG}
                value={weightIn ?? 60}
                onChange={(e) => set({ weightIn: Number(e.target.value) })}
              />
            </div>
          </div>
        </div>

        {/* Continue */}
        <button
          className={`${styles.persona2ContinueBtn} ${styles.CBheading3}`}
          onClick={handleContinue}
        >
          Continue →
        </button>
      </div>
    </div>
  );
}

